import { Collapse } from 'bootstrap5';
window.TABS = window.TABS || {};

window.TABS.util = {
    getUrlParameter: function (searchParam) {
        var sPageURL = window.location.search.substring(1);
        var sURLVariables = sPageURL.split('&');
        for (var i = 0; i < sURLVariables.length; i++) {
            var sParameterName = sURLVariables[i].split('=');
            if (sParameterName[0] === searchParam) {
                return sParameterName[1];
            }
        }
    }
}